import './objectFitPolyfill'

export const vidHelper = () => {
  const vids = Array.from(document.querySelectorAll('.video-react-video'))
  vids.forEach(vid => {
    vid.setAttribute('data-object-fit', 'cover')
    vid.setAttribute('data-object-position', 'center center')
  })
  window.objectFitPolyfill()
}
/**
 * 数据保存到sessionStorage
 * @param key
 * @param value
 */
export function setSession (key, value) {
  // console.log('key=', key)
  // console.log('value=', value)
  if (value === undefined || key === undefined) {
    return
  }
  if (typeof value === 'number' || typeof value === 'string') {
    sessionStorage[`${key}`] = value
  } else if (typeof value === 'object' && value !== null) {
    sessionStorage[`${key}`] = JSON.stringify(value)
  }
}

/**
 * 获取sessionStorage数据
 * @param key
 * @param key
 */
export function getSession (key) {
  if (!sessionStorage[`${key}`]) {
    return
  }
  var value = sessionStorage[`${key}`]
  var index1 = value.indexOf('[')
  var index2 = value.indexOf('{')
  if (index1 >= 0 || (index2 >= 0)) {
    value = JSON.parse(sessionStorage[`${key}`])
  }
  return value
}
